/**
 * Created by mmaillot on 7/21/16.
 */

import ConfigScenario from './ConfigScenario'
import ConfigGps from './ConfigGps'

export default class Config {
    constructor(campaignId, confVersion, refreshConfigInterval = 3600, gpsConfig, scenarios, groupId) {
        this.campaignId = campaignId;
        this.confVersion = parseInt(confVersion);
        this.refreshConfigInterval = parseInt(refreshConfigInterval);
        this.gpsConfig = gpsConfig;
        this.scenarios = scenarios;
        if (groupId) {
            this.groupId = groupId;
        } else {
            this.groupId = 0;
        }
        Object.freeze(this);
    }


    static restore(obj) {
        let scenarios = [];
        obj.scenarios.forEach(function (s) {
            scenarios.push(ConfigScenario.restore(s));
        });

        return new Config(
            obj.campaignId,
            obj.confVersion,
            obj.refreshConfigInterval,
            ConfigGps.restore(obj.gpsConfig),
            scenarios,
            obj.groupId
        );
    }
}


// WEBPACK FOOTER //
// ./js/core/configuration/config/Config.js